export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9751.e0a827a4.jpg";